import { z } from 'zod';
import { localizedTextSchema } from './localizedText.js';
// One answered offer-flow question. Both sides are localized because the offer flow caches every language's
// wording at submit time, so no translation round trip is needed to show them.
export const offerRequestInfoFieldSchema = z.object({
    question: localizedTextSchema,
    answer: localizedTextSchema,
});
